/**
 * Normalize a raw `preferred_styles` value from the API against the set of
 * currently-visible style keys.
 *
 * Defensive rules:
 *  - If `raw` is not an array (e.g. a string, null, undefined), return [].
 *    This prevents char-iterating a string like "House" into {"H","o","u","s","e"}.
 *  - Each element is coerced to string before the lookup.
 *  - Keys not present in `validKeys` (orphaned / hidden styles) are dropped.
 */
export function normalizePicks(raw: unknown, validKeys: Set<string>): string[] {
  if (!Array.isArray(raw)) return [];
  return raw.map(String).filter((k) => validKeys.has(k));
}
